export const LogicCategoryShowName = (catesim) => {
  // console.log();

  if (catesim) {
    let arrNameCate = '';
    switch (catesim) {
      case 'than-tai':
        arrNameCate = 'Sim Thần Tài';
        break;
      case 'phat-loc':
        arrNameCate = 'Sim Phát Lộc';
        break;
      case 'loc-phat':
        arrNameCate = 'Sim Lộc Phát';
        break;
      case 'tho-dia':
        arrNameCate = 'Sim Ông Địa';
        break;
      case 'phong-thuy':
        arrNameCate = 'Sim Phong Thủy';
        break;
      case 'tam-hoa':
        arrNameCate = 'Sim Tam Hoa';
        break;
      case 'sanh-tien':
        arrNameCate = 'Sim Sảnh Tiến';
        break;
      case 'sanh-tien-3':
        arrNameCate = 'Sảnh Tiến 3';
        break;
      case 'sanh-tien-4':
        arrNameCate = 'Sảnh Tiến 4';
        break;
      case 'ngu-quy':
        arrNameCate = 'Sim Ngũ Quý';
        break;
      case 'tu-quy':
        arrNameCate = 'Sim Tứ Quý';
        break;
      case 'luc-quy':
        arrNameCate = 'Sim Lục Quý';
        break;
      case 'doc-la':
        arrNameCate = 'Sim Độc Lạ';
        break;
      case 'dac-biet':
        arrNameCate = 'Sim Đặc Biệt';
        break;
      case 'ganh-dao':
        arrNameCate = 'Sim Gánh Đảo';
        break;
      case 'lap':
        arrNameCate = 'Sim Lặp';
        break;
      case 'tam-hoa-kep':
        arrNameCate = 'Tam Hoa Kép';
        break;
      case 'taxi':
        arrNameCate = 'Sim Taxi';
        break;
      case 'taxi-2':
        arrNameCate = 'Sim Taxi 2';
        break;
      case 'tu-quy-giua':
        arrNameCate = 'Tứ Quý Giữa';
        break;
      case 'ngu-quy-giua':
        arrNameCate = 'Ngũ Quý Giữa';
        break;
      case 'nam-sinh':
        arrNameCate = 'Sim Năm Sinh';
        break;
      case 'taxi-tien':
        arrNameCate = 'Sim Taxi Tiến';
        break;
      case 'moc':
        arrNameCate = 'Sim Mệnh Mộc';
        break;
      case 'thuy':
        arrNameCate = 'Sim Mệnh Thủy';
        break;
      case 'tho':
        arrNameCate = 'Sim Mệnh Thổ';
        break;
      case 'hoa':
        arrNameCate = 'Sim Mệnh Hỏa';
        break;
      case 'kim':
        arrNameCate = 'Sim Mệnh Kim';
        break;

      default:
        arrNameCate = '';
        break;
    }

    return arrNameCate ? arrNameCate : ``;
  }
};
export const showMenhSim = (catesim) => {
  // console.log();

  if (catesim) {
    let arrNameCate = '';
    switch (catesim) {
      case 'than-tai':
        arrNameCate = 'Sim Thần Tài';
        break;
      case 'phat-loc':
        arrNameCate = 'Sim Phát Lộc';
        break;
      case 'loc-phat':
        arrNameCate = 'Sim Lộc Phát';
        break;
      case 'tho-dia':
        arrNameCate = 'Sim Ông Địa';
        break;
      case 'phong-thuy':
        arrNameCate = 'Sim Phong Thủy';
        break;
      case 'tam-hoa':
        arrNameCate = 'Sim Tam Hoa';
        break;
      case 'sanh-tien':
        arrNameCate = 'Sim Sảnh Tiến';
        break;
      case 'sanh-tien-3':
        arrNameCate = 'Sảnh Tiến 3';
        break;
      case 'sanh-tien-4':
        arrNameCate = 'Sảnh Tiến 4';
        break;
      case 'ngu-quy':
        arrNameCate = 'Sim Ngũ Quý';
        break;
      case 'tu-quy':
        arrNameCate = 'Sim Tứ Quý';
        break;
      case 'luc-quy':
        arrNameCate = 'Sim Lục Quý';
        break;
      case 'doc-la':
        arrNameCate = 'Sim Độc Lạ';
        break;
      case 'dac-biet':
        arrNameCate = 'Sim Đặc Biệt';
        break;
      case 'ganh-dao':
        arrNameCate = 'Sim Gánh Đảo';
        break;
      case 'lap':
        arrNameCate = 'Sim Lặp';
        break;
      case 'tam-hoa-kep':
        arrNameCate = 'Tam Hoa Kép';
        break;
      case 'taxi':
        arrNameCate = 'Sim Taxi';
        break;
      case 'taxi-2':
        arrNameCate = 'Sim Taxi 2';
        break;
      case 'tu-quy-giua':
        arrNameCate = 'Tứ Quý Giữa';
        break;
      case 'ngu-quy-giua':
        arrNameCate = 'Ngũ Quý Giữa';
        break;
      case 'nam-sinh':
        arrNameCate = 'Sim Năm Sinh';
        break;
      case 'taxi-tien':
        arrNameCate = 'Sim Taxi Tiến';
        break;
      case 'moc':
        arrNameCate = 'Mộc';
        break;
      case 'thuy':
        arrNameCate = 'Thủy';
        break;
      case 'tho':
        arrNameCate = 'Thổ';
        break;
      case 'hoa':
        arrNameCate = 'Hỏa';
        break;
      case 'kim':
        arrNameCate = 'Kim';
        break;

      default:
        arrNameCate = '';
        break;
    }

    return arrNameCate ? arrNameCate : ``;
  }
};

export const LogicShowNameMenhSim = (catesim) => {
  // console.log();

  if (catesim) {
    let arrNameCate = '';
    switch (catesim) {
      case 'than-tai':
        arrNameCate = 'Thần Tài';
        break;
      case 'phat-loc':
        arrNameCate = 'Phát Lộc';
        break;
      case 'loc-phat':
        arrNameCate = 'Lộc Phát';
        break;
      case 'tho-dia':
        arrNameCate = 'Ông Địa';
        break;
      case 'phong-thuy':
        arrNameCate = 'Phong Thủy';
        break;
      case 'tam-hoa':
        arrNameCate = 'Tam Hoa';
        break;
      case 'sanh-tien':
        arrNameCate = 'Sảnh Tiến';
        break;
      case 'sanh-tien-3':
        arrNameCate = 'STiến 3';
        break;
      case 'sanh-tien-4':
        arrNameCate = 'STiến 4';
        break;
      case 'ngu-quy':
        arrNameCate = 'Ngũ Quý';
        break;
      case 'tu-quy':
        arrNameCate = 'Tứ Quý';
        break;
      case 'luc-quy':
        arrNameCate = 'Lục Quý';
        break;
      case 'doc-la':
        arrNameCate = 'Độc Lạ';
        break;
      case 'dac-biet':
        arrNameCate = 'Đặc Biệt';
        break;
      case 'ganh-dao':
        arrNameCate = 'Gánh Đảo';
        break;
      case 'lap':
        arrNameCate = 'Lặp';
        break;
      case 'tam-hoa-kep':
        arrNameCate = 'Tam Hoa Kép';
        break;
      case 'taxi':
        arrNameCate = 'Taxi';
        break;
      case 'taxi-2':
        arrNameCate = 'Taxi 2';
        break;
      case 'tu-quy-giua':
        arrNameCate = 'Tứ Quý Giữa';
        break;
      case 'ngu-quy-giua':
        arrNameCate = 'Ngũ Quý Giữa';
        break;
      case 'nam-sinh':
        arrNameCate = 'Năm Sinh';
        break;
      case 'taxi-tien':
        arrNameCate = 'Taxi Tiến';
        break;
      case 'moc':
        arrNameCate = 'Mộc';
        break;
      case 'thuy':
        arrNameCate = 'Thủy';
        break;
      case 'tho':
        arrNameCate = 'Thổ';
        break;
      case 'hoa':
        arrNameCate = 'Hỏa';
        break;
      case 'kim':
        arrNameCate = 'Kim';
        break;

      default:
        arrNameCate = '';
        break;
    }

    return arrNameCate ? arrNameCate : ``;
  }
};

// export function getSimMenh(phoneNumber) {
//   if (!phoneNumber) return null;

//   // Bảng mapping từ tổng -> mệnh
//   const menhMap = {
//     1: 'Thuỷ',
//     2: 'Thổ',
//     3: 'Mộc',
//     4: 'Mộc',
//     5: 'Thuỷ',
//     6: 'Kim',
//     7: 'Kim',
//     8: 'Thổ',
//     9: 'Hoả',
//   };

//   // Tính tổng các số trong sim
//   const digits = phoneNumber.replace(/\D/g, '').split('').map(Number);
//   let sum = digits.reduce((a, b) => a + b, 0);

//   // Nếu tổng > 81 thì giảm về khoảng 1-81
//   while (sum > 81) {
//     sum = sum
//       .toString()
//       .split('')
//       .map(Number)
//       .reduce((a, b) => a + b, 0);
//   }

//   // Tìm "tổng 2" bằng cách rút gọn tổng đến 1 chữ số
//   let total2 = sum;
//   while (total2 > 9) {
//     total2 = total2
//       .toString()
//       .split('')
//       .map(Number)
//       .reduce((a, b) => a + b, 0);
//   }

//   // "Tổng 3" = chính là số sau cùng
//   const total3 = total2;

//   // Tra mệnh theo bảng (dựa vào total3)
//   const menh = menhMap[total3];
//   const css =
//     menh === 'Kim' ? 'kim' : menh === 'Thuỷ' ? 'thuy' : menh === 'Hoả' ? 'hoa' : menh === 'Thổ' ? 'tho' : 'moc';

//   return {
//     phoneNumber,
//     sum, // Tổng ban đầu (<=81)
//     total2, // Rút gọn 1 chữ số
//     total3, // Trùng với total2
//     menh,
//     css,
//   };
// }

export function getSimMenh(phoneNumber) {
  if (!phoneNumber) return null;

  // 1. Loại bỏ ký tự không phải số
  const digits = phoneNumber.replace(/\D/g, '');

  // 2. Kiểm tra độ dài phải là 9 hoặc 10 số
  if (digits.length < 9 || digits.length > 10) {
    return null;
  }

  // 3. Cộng tổng các chữ số
  let sum = digits.split('').reduce((acc, num) => acc + parseInt(num, 10), 0);

  // 4. Rút gọn còn 1 số
  while (sum > 9) {
    sum = sum
      .toString()
      .split('')
      .reduce((acc, num) => acc + parseInt(num, 10), 0);
  }

  // 5. Map số sang mệnh
  const menhMap = {
    1: 'Thủy',
    2: 'Thổ',
    3: 'Mộc',
    4: 'Mộc',
    5: 'Thổ',
    6: 'Kim',
    7: 'Kim',
    8: 'Thổ',
    9: 'Hỏa',
    0: 'Thủy',
  };

  const tuongSinhMap = {
    Mộc: 'Hỏa',
    Hỏa: 'Thổ',
    Thổ: 'Kim',
    Kim: 'Thủy',
    Thủy: 'Mộc',
  };

  const menh = menhMap[sum];
  if (!menh) return null; // phòng trường hợp không map được

  const menhts = tuongSinhMap[menh] || null;

  const css =
    menh === 'Kim' ? 'kim' : menh === 'Thủy' ? 'thuy' : menh === 'Hỏa' ? 'hoa' : menh === 'Thổ' ? 'tho' : 'moc';

  const cssts =
    menhts === 'Kim' ? 'kim' : menhts === 'Thủy' ? 'thuy' : menhts === 'Hỏa' ? 'hoa' : menhts === 'Thổ' ? 'tho' : 'moc';

  return {
    soCuoi: sum,
    menh,
    menhts, // mệnh tương sinh
    css,
    cssts,
  };
}
// 1) Bản đồ quái (số 1..8 => tên quái)
const quaiMap = {
  1: 'Càn (Thiên)',
  2: 'Đoài (Trạch)',
  3: 'Ly (Hỏa)',
  4: 'Chấn (Lôi)',
  5: 'Tốn (Phong)',
  6: 'Khảm (Thủy)',
  7: 'Cấn (Sơn)',
  8: 'Khôn (Địa)',
};

// 2) Lưới (grid) 8x8: mỗi hàng là LOWER quái (1..8), mỗi cột là UPPER quái (1..8).
// Dữ liệu số quẻ lấy theo bảng "lookup table" của I Ching (King Wen order).
const grid = [
  /* lower = 1 (Càn) */ [1, 43, 14, 34, 9, 5, 26, 11],
  /* lower = 2 (Đoài)*/ [10, 58, 38, 54, 61, 60, 41, 19],
  /* lower = 3 (Ly)  */ [13, 49, 30, 55, 37, 63, 22, 36],
  /* lower = 4 (Chấn)*/ [25, 17, 21, 51, 42, 3, 27, 24],
  /* lower = 5 (Tốn) */ [44, 28, 50, 32, 57, 48, 18, 46],
  /* lower = 6 (Khảm)*/ [6, 47, 64, 40, 59, 29, 4, 7],
  /* lower = 7 (Cấn) */ [33, 31, 56, 62, 53, 39, 52, 15],
  /* lower = 8 (Khôn)*/ [12, 45, 35, 16, 20, 8, 23, 2],
];

// 3) Bảng 64 quẻ theo số -> chữ Hán + tên tiếng Anh + tên tiếng Việt ngắn + mô tả ngắn (tiếng Việt).
// (Tên & mô tả ngắn dựa trên danh mục quẻ chuẩn; mình để ngắn gọn để tiện dùng programmatic)
const hexByNumber = {
  1: { ch: '乾', en: 'Force', vn: 'Thuần Càn', desc: 'Sức mạnh, sáng tạo, đại cát' },
  2: { ch: '坤', en: 'Field', vn: 'Thuần Khôn', desc: 'Nhận, nuôi dưỡng, nhu thuận' },
  3: {
    ch: '屯',
    en: 'Sprouting (Difficulty at the Beginning)',
    vn: 'Trụn/Khởi đầu khó',
    desc: 'Khó khăn lúc bắt đầu, cần kiên nhẫn',
  },
  4: { ch: '蒙', en: 'Enveloping (Youthful Folly)', vn: 'Mông', desc: 'Thiếu kinh nghiệm; cần học hỏi' },
  5: { ch: '需', en: 'Waiting (Attending)', vn: 'Nhu', desc: 'Chờ đợi, tích trữ sức' },
  6: { ch: '訟', en: 'Conflict', vn: 'Tụng/Tranh chấp', desc: 'Tranh chấp, kiện tụng' },
  7: { ch: '師', en: 'The Army', vn: 'Sư/Quân', desc: 'Tổ chức, kỷ luật, tập hợp lực lượng' },
  8: { ch: '比', en: 'Holding Together', vn: 'Bỉ/Đoàn kết', desc: 'Đoàn kết, hợp lực' },
  9: { ch: '小畜', en: 'Small Taming', vn: 'Tiểu xú', desc: 'Kiềm chế nhỏ, tích lũy' },
  10: { ch: '履', en: 'Treading', vn: 'Lữ/Hành xử', desc: 'Hành vi thận trọng, cư xử' },
  11: { ch: '泰', en: 'Peace', vn: 'Thái', desc: 'Hòa hợp, hanh thông' },
  12: { ch: '否', en: 'Stagnation', vn: 'Bỉ', desc: 'Bế tắc, không thông' },
  13: { ch: '同人', en: 'Fellowship with Men', vn: 'Đồng nhân', desc: 'Đoàn kết, quan hệ xã hội' },
  14: { ch: '大有', en: 'Great Possessing', vn: 'Đại hữu', desc: 'Giàu có, thành tựu lớn' },
  15: { ch: '謙', en: 'Modesty', vn: 'Khiêm', desc: 'Khiêm nhường đem lợi' },
  16: { ch: '豫', en: 'Providing-For (Enthusiasm)', vn: 'Dự', desc: 'Chuẩn bị, nhiệt huyết' },
  17: { ch: '隨', en: 'Following', vn: 'Tùy', desc: 'Theo sau, thích nghi' },
  18: { ch: '蠱', en: 'Correcting', vn: 'Cổ', desc: 'Sửa chữa, chỉnh đốn' },
  19: { ch: '臨', en: 'Approach', vn: 'Lâm', desc: 'Tiếp cận, đến gần' },
  20: { ch: '觀', en: 'Contemplation (View)', vn: 'Quan', desc: 'Quan sát, suy ngẫm' },
  21: { ch: '噬嗑', en: 'Biting Through', vn: 'Thứ/Khắc phục', desc: 'Xử lý chướng ngại' },
  22: { ch: '賁', en: 'Grace (Adorning)', vn: 'Bì', desc: 'Duyên dáng, vẻ bề ngoài' },
  23: { ch: '剝', en: 'Splitting Apart', vn: 'Bác/Thoái', desc: 'Suy tàn, mất mát' },
  24: { ch: '復', en: 'Return', vn: 'Phục', desc: 'Quay lại, hồi phục' },
  25: { ch: '無妄', en: 'Innocence', vn: 'Vô vọng', desc: 'Tự nhiên, vô ý kết quả tốt' },
  26: { ch: '大畜', en: 'Great Taming', vn: 'Đại xú', desc: 'Tích lũy lớn, kiềm chế' },
  27: { ch: '頤', en: 'Nourishment', vn: 'Dư', desc: 'Nuôi dưỡng, giữ gìn' },
  28: { ch: '大過', en: 'Great Exceeding', vn: 'Đại quá', desc: 'Quá mức, dễ vỡ' },
  29: { ch: '坎', en: 'The Abysmal (Water)', vn: 'Hãm', desc: 'Thử thách, hiểm nguy' },
  30: { ch: '離', en: 'The Clinging (Fire)', vn: 'Ly', desc: 'Rực rỡ, dễ nhìn' },
  31: { ch: '咸', en: 'Influence (Wooing)', vn: 'Hảm', desc: 'Cảm hóa, ảnh hưởng lẫn nhau' },
  32: { ch: '恒', en: 'Duration (Constancy)', vn: 'Hằng', desc: 'Bền bỉ, lâu dài' },
  33: { ch: '遯', en: 'Retreat', vn: 'Đốn', desc: 'Rút lui đúng lúc' },
  34: { ch: '大壯', en: 'Great Power', vn: 'Đại tráng', desc: 'Sức mạnh lớn, hành động mạnh mẽ' },
  35: { ch: '晉', en: 'Progress', vn: 'Tiến', desc: 'Thăng tiến, phát triển' },
  36: { ch: '明夷', en: 'Darkening of the Light', vn: 'Minh y', desc: 'Ánh sáng che lấp, thận trọng' },
  37: { ch: '家人', en: 'The Family', vn: 'Gia nhân', desc: 'Gia đình, trật tự nội bộ' },
  38: { ch: '睽', en: 'Opposition', vn: 'Khuy', desc: 'Đối lập, bất hòa' },
  39: { ch: '蹇', en: 'Obstruction', vn: 'Kiển', desc: 'Trở ngại, chậm trễ' },
  40: { ch: '解', en: 'Deliverance', vn: 'Giải', desc: 'Giải thoát, tháo gỡ' },
  41: { ch: '損', en: 'Decrease', vn: 'Tổn', desc: 'Giảm bớt, từ bỏ để đạt lợi lớn' },
  42: { ch: '益', en: 'Increase', vn: 'Ích', desc: 'Gia tăng, thu hoạch' },
  43: { ch: '夬', en: 'Breakthrough', vn: 'Quải', desc: 'Đột phá, quyết đoán' },
  44: { ch: '姤', en: 'Coming to Meet', vn: 'Cấu', desc: 'Gặp gỡ, cảnh giác' },
  45: { ch: '萃', en: 'Gathering Together', vn: 'Tụy', desc: 'Tập hợp, sức mạnh chung' },
  46: { ch: '升', en: 'Pushing Upward', vn: 'Thăng', desc: 'Tiến lên, thăng tiến nhỏ' },
  47: { ch: '困', en: 'Oppression', vn: 'Khốn', desc: 'Khốn khổ, bị ép' },
  48: { ch: '井', en: 'The Well', vn: 'Tỉnh', desc: 'Nguồn lực, nền tảng' },
  49: { ch: '革', en: 'Revolution', vn: 'Cách', desc: 'Thay đổi, cải tổ mạnh' },
  50: { ch: '鼎', en: 'The Cauldron', vn: 'Đỉnh', desc: 'Văn hóa, nền tảng tinh thần' },
  51: { ch: '震', en: 'The Arousing (Shock)', vn: 'Chấn', desc: 'Chấn động, khởi động' },
  52: { ch: '艮', en: 'Keeping Still', vn: 'Cấn', desc: 'Tĩnh lặng, dừng nghỉ' },
  53: { ch: '漸', en: 'Development', vn: 'Tiến dần', desc: 'Phát triển chậm, bền vững' },
  54: { ch: '歸妹', en: 'The Marrying Maiden', vn: 'Quy muội', desc: 'Quan hệ hôn nhân, vị trí phụ thuộc' },
  55: { ch: '豐', en: 'Abundance', vn: 'Phùng', desc: 'Phong túc, thịnh vượng' },
  56: { ch: '旅', en: 'The Wanderer', vn: 'Lữ', desc: 'Lưu lạc, tạm bợ' },
  57: { ch: '巽', en: 'The Gentle (Wind)', vn: 'Tốn', desc: 'Linh hoạt, thấm nhuần' },
  58: { ch: '兌', en: 'The Joyous (Lake)', vn: 'Đoài', desc: 'Vui vẻ, dễ gần' },
  59: { ch: '渙', en: 'Dispersion', vn: 'Hoán', desc: 'Giải tán, hoá giải mâu thuẫn' },
  60: { ch: '節', en: 'Limitation', vn: 'Tiết', desc: 'Giới hạn, khuôn phép' },
  61: { ch: '中孚', en: 'Inner Truth', vn: 'Trung Phu', desc: 'Chân thành bên trong' },
  62: { ch: '小過', en: 'Small Exceeding', vn: 'Tiểu quá', desc: 'Chi tiết nhỏ, tránh cực đoan' },
  63: { ch: '既濟', en: 'After Completion', vn: 'Ký tế', desc: 'Hoàn tất, kết thúc' },
  64: { ch: '未濟', en: 'Before Completion', vn: 'Vị tế', desc: 'Chưa hoàn tất, cần thận trọng' },
};

// 4) Tạo que64 mapping từ grid + hexByNumber:
// key = `${upper}${lower}` (ví dụ '46' nghĩa upper=4, lower=6)
const que64 = {};
for (let lowerIndex = 0; lowerIndex < 8; lowerIndex++) {
  for (let upperIndex = 0; upperIndex < 8; upperIndex++) {
    const upper = upperIndex + 1; // 1..8
    const lower = lowerIndex + 1; // 1..8
    const hexNum = grid[lowerIndex][upperIndex];
    const info = hexByNumber[hexNum] || { ch: '?', en: 'Unknown', vn: 'Chưa có', desc: '' };
    const key = `${upper}${lower}`; // upper then lower
    que64[key] = {
      key,
      upper: { idx: upper, name: quaiMap[upper] },
      lower: { idx: lower, name: quaiMap[lower] },
      hexNum,
      hex: info,
    };
  }
}

// 5) Hàm chính: tính quẻ Chủ từ số điện thoại
export function tinhQueChu(phoneNumber) {
  if (!phoneNumber) throw new Error('Thiếu số điện thoại');
  const digits = ('' + phoneNumber).replace(/\D/g, '');
  if (![10, 11].includes(digits.length)) {
    throw new Error('Hệ thống chỉ hỗ trợ sim 10 hoặc 11 số');
  }
  const mid = digits.length === 10 ? 5 : 6;
  const upperDigits = digits.slice(0, mid);
  const lowerDigits = digits.slice(mid);

  const sum = (s) => [...s].reduce((a, c) => a + parseInt(c, 10), 0);
  const sumUpper = sum(upperDigits);
  const sumLower = sum(lowerDigits);

  const getQuai = (s) => {
    const mod = s % 8;
    return mod === 0 ? 8 : mod;
  };

  const uQuai = getQuai(sumUpper);
  const lQuai = getQuai(sumLower);
  const key = `${uQuai}${lQuai}`;
  const que = que64[key] || null;

  return {
    input: phoneNumber,
    digits,
    upperDigits,
    lowerDigits,
    sumUpper,
    sumLower,
    uQuai,
    lQuai,
    queChu: que,
  };
}
